import { rootApi } from "../user/api";

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ["DispatchBoard"],
});

export const dispatchBoardApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findTripDetailByJobcode: builder.query({
      query: (payload) => {
        let url = `dispatch_boards/?job_code=${payload.job_code}`;

        return { url: url };
      },
      keepUnusedDataFor: 0,
      providesTags: ["DispatchBoard"],
    }),

    findAllErrorDispatchBoards: builder.query({
      query: (payload) => {
        let url = `dispatch_boards/?is_valid=false`;
        return { url };
      },
      keepUnusedDataFor: 0,
      providesTags: ["DispatchBoard"],
    }),
    createDispatchBoardByYardout: builder.mutation({
      query: (payload) => ({
        url: `dispatch_boards/create_by_yardout/`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["DispatchBoard"],
    }),
    uploadDiagramPlan: builder.mutation({
      query: ({ file, utcOffset }) => ({
        url: `upload_diagram_plan/${file.name}/`,
        method: "POST",
        body: (() => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("utcOffset", utcOffset);
          return formData;
        })(),
      }),
      invalidatesTags: ["DispatchBoard"],
    }),
    createDiagramPlan: builder.mutation({
      query: (diagramPlan) => ({
        url: `dispatch_boards/`,
        method: "POST",
        body: diagramPlan,
      }),
      invalidatesTags: ["DispatchBoard"],
    }),
    updateDiagramPlan: builder.mutation({
      query: (diagramPlan) => ({
        url: `dispatch_boards/${diagramPlan.id}/`,
        method: "PATCH",
        body: diagramPlan,
      }),
      invalidatesTags: ["DispatchBoard"],
    }),

    //new

    /*get data company BZP */
    getDataOptionCompany: builder.query({
      query: () => `dispatch_boards_new/company/`,
      keepUnusedDataFor: 0,
      providesTags: ["DispatchBoard"],
    }),
    /*get data diagram owner */
    getDataOptionDiagramOwner: builder.query({
      query: () => `diagram_owners/user/`,
      keepUnusedDataFor: 0,
      providesTags: ["DispatchBoard"],
    }),
    /*get data Permission */
    getPermissionGroup: builder.query({
      query: () => `function_permission/user/`,
      keepUnusedDataFor: 0,
      providesTags: ["DispatchBoard"],
    }),

    // get all data dispetch board
    findAllDispatchBoardsNewByDatetime: builder.query({
      query: (payload) => {
        let url = `dispatch_boards_new/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ["DispatchBoard"],
    }),
    /* selection From Diagram type */
    getDataSelectionFromDiagram: builder.query({
      query: (payload) => {
        let url = `dispatch_boards_new/selection_data/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ["DispatchBoard"],
    }),
    // summary
    findSummaryDispatchBoardsNewByDatetime: builder.query({
      query: (payload) => {
        let url = `dispatch_boards_new/summary/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ["DispatchBoard"],
    }),
    /*get Calling complete */
    getCallingComplete: builder.query({
      query: () =>
        `callingsheetsnew/number_calling/?location_from=All&region_id=All&cluster_id=All`,
      keepUnusedDataFor: 0,
      providesTags: ["DispatchBoard"],
    }),

    // cancel match calling
    cancelMatchCalling: builder.mutation({
      query: (id) => ({
        url: `manage_callingsheets/cancel_matching/${id}/`,
        method: "PUT",
      }),
      keepUnusedDataFor: 0,
      // invalidatesTags: ["DispatchBoard"],
    }),

    /*Cancel Match Trailer & Driver */
    cancelMatchTrailerDriver: builder.mutation({
      query: (dispatch_board_id) => ({
        url: `dispatch_boards_new/delete/trailer_and_driver/${dispatch_board_id}/`,
        method: "DELETE",
      }),
      keepUnusedDataFor: 0,
      // invalidatesTags: ["DispatchBoard"],
    }),

    /*canceMatchlPlan */
    cancelMatchPlan: builder.mutation({
      query: (Body) => ({
        url: `dispatch_boards_new/reason/${Body.dispatch_board_id}/`,
        method: "PUT",
        body: Body,
      }),
      keepUnusedDataFor: 0,
      // invalidatesTags: ["DispatchBoard"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindTripDetailByJobcodeQuery,

  useFindAllErrorDispatchBoardsQuery,
  useUploadDiagramPlanMutation,
  useCreateDiagramPlanMutation,
  useUpdateDiagramPlanMutation,
  useCreateDispatchBoardByYardoutMutation,

  //new
  useGetDataOptionCompanyQuery,
  useGetDataOptionDiagramOwnerQuery,
  useFindAllDispatchBoardsNewByDatetimeQuery,
  useGetDataSelectionFromDiagramQuery,
  useFindSummaryDispatchBoardsNewByDatetimeQuery,
  useGetPermissionGroupQuery,
  useGetCallingCompleteQuery,

  useCancelMatchTrailerDriverMutation,
  useCancelMatchPlanMutation,
  useCancelMatchCallingMutation,
} = dispatchBoardApi;
